import { useQuery } from '@tanstack/react-query';
import {
  type Catalogue_SystemSettingsFilter,
  type Catalogue_SystemSettingsViewQuery,
  type UseQueryReturnType,
  gqlClient,
  graphql,
  queryClient,
} from '@tyro/api';
import { useCallback } from 'react';
import { systemKeys } from './keys';

const settingsView = graphql(/* GraphQL */ `
   query catalogue_systemSettingsView($filter: Catalogue_SystemSettingsFilter!) {
    catalogue_systemSettingsView(filter: $filter) {
      id {
        module
        category
        nameId
      }
      moduleName
      categoryName
    	label
      labelTextId
    	description
    	fieldType
      value
      selectValues{
        label
        value
      }
    }
  }
`);

const settingsViewQuery = (filter: Catalogue_SystemSettingsFilter) => ({
  queryKey: systemKeys.settingsView(filter),
  queryFn: () => gqlClient.request(settingsView, { filter }),
});

export function getSettingsView(filter: Catalogue_SystemSettingsFilter) {
  return queryClient.fetchQuery(settingsViewQuery(filter));
}

export function useSettingsView(filter: Catalogue_SystemSettingsFilter) {
  return useQuery({
    ...settingsViewQuery(filter),
    select: useCallback(
      ({ catalogue_systemSettingsView }: Catalogue_SystemSettingsViewQuery) =>
        catalogue_systemSettingsView.flatMap((view) => (view ? [view] : [])),
      [],
    ),
  });
}

export type ReturnTypeFromUseSettingsView = UseQueryReturnType<
  typeof useSettingsView
>[number];
